import { useSelector } from 'react-redux'
import { openBotIdSelector } from '../selectors'

export function useOpenBotId(): string | undefined {
  return useSelector(openBotIdSelector)
}
